import utils from "../../utils";
import CustomIcon from "../CustomIcon";

import React, { useContext } from "react";

import "./index.scss";
import Cookies from "js-cookie";
import constants from "../../values/constants";
import Context from "../../context";
import { useTranslation } from "react-i18next";

interface Props {
  balance          ?: string;
  availableFund    ?: string;
  deptAdmin2Company?: string;
}

const WalletIcon = ({ balance, availableFund, deptAdmin2Company }: Props) => {
  const userType: string = utils.stringHexConversion.reverse(Cookies.get(constants.USER.TYPE));
  const { userInfo } = useContext(Context.UserScreen);

  const { t } = useTranslation();

  return (
    <div className="wallets">
      {balance &&
        ((userType === "ADMIN" && userInfo?.isPrimary) && (
          <>
            <div className="wallet">
              <span>
                {utils.convertNumberToPrice(Math.floor(Number(balance as string)))} {t("toman")}
              </span>
            </div>
            <div className="profit-wallet">
              <CustomIcon icon="fas fa-credit-card" hoverTitle={'پول قابل برداشت'} type="primary"/>
              <span>
                {utils.convertNumberToPrice(Math.floor(Number(availableFund as string)))} {t("toman")}
              </span>
            </div>
          </>
        ))}
      {userType === "COMPANY" && (
        <>
          <div className="wallet">
            <CustomIcon icon="fas fa-credit-card" hoverTitle={'محموع پول در حساب'} type="success"/>
            <span>
                {utils.convertNumberToPrice(Math.floor(Number(balance as string)))} {t("toman")}
              </span>
          </div>
          <div className="profit-wallet">
            <CustomIcon icon="fas fa-credit-card" hoverTitle={'پول قابل برداشت'} type="primary"/>
            <span>
                {utils.convertNumberToPrice(Math.floor(Number(deptAdmin2Company as string)))} {t("toman")}
              </span>
          </div>
        </>
      )}
    </div>
  );
};

export default WalletIcon;
